<template>
    <bottom-sheet v-model="shows" title="지원하기" fullscreen persistent width="1080" maxWidth="95%" needsLogin v-bind="{ userType }">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents">
            <application-form-card v-if="shows" v-bind="{ _recruitment, recruitmentSubject }" @close="shows = false" />
        </v-layout>
    </bottom-sheet>
</template>

<script>
import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ApplicationFormCard from "./application-form-card.vue";
import { USER_TYPES } from "@/assets/variables";

const initInputs = () => ({});

export default {
    components: {
        BottomSheet,
        ApplicationFormCard,
    },
    props: {
        _recruitment: { type: String },
        recruitmentSubject: { type: String },
    },
    data: () => ({
        inputs: initInputs(),

        shows: false,
        loading: false,
        userType: USER_TYPES.PERSON.value,
    }),
};
</script>
